/**
 * URLs das versoes reduzidas das imagens de produto.
 *
 * A vitrine exibe o produto a cerca de 200 px e ate agora baixava o original,
 * que tem entre 600 e 1365 px de largura e pesa em media 144 KB. O painel gera
 * a versao reduzida na primeira vez que a URL e pedida e grava em disco
 * (App\Services\ImageVariantService), entao aqui basta montar a URL:
 *
 *     https://sistema.fflip.com.br/images/products/siggma2127-4843.jpg
 *     https://sistema.fflip.com.br/images/products/w300/siggma2127-4843.jpg.webp
 *
 * O nome do original fica inteiro, com extensao e tudo, porque products/ tem
 * arquivos de mesmo nome em .jpg e .png convivendo.
 *
 * As larguras precisam bater com config/images.php do painel: pedir uma
 * largura que nao esta la devolve o original, nao um erro, mas tambem nao
 * economiza nada.
 */
export const PRODUCT_IMAGE_WIDTHS = [300, 600, 1080]

/**
 * So imagens que estao em products/ tem variante. URL com query string,
 * imagem de outra pasta ou link externo caem fora e o chamador segue usando o
 * original.
 */
const PRODUCT_IMAGE = /^(.*\/products)\/([^/?#]+)$/

export function productImageVariant(url, width) {
    const parts = typeof url === 'string' ? url.match(PRODUCT_IMAGE) : null

    return parts ? `${parts[1]}/w${width}/${parts[2]}.webp` : null
}

export function productImageSrcset(url, widths = PRODUCT_IMAGE_WIDTHS) {
    const candidates = widths
        .map(width => {
            const variant = productImageVariant(url, width)

            return variant ? `${variant} ${width}w` : null
        })
        .filter(Boolean)

    return candidates.length ? candidates.join(', ') : null
}
